import * as geolib from 'geolib';
import React from 'react';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardControlKey as KeyboardControlKeyIcon,
  Call as CallIcon,
} from '@mui/icons-material';
import { ErrorAlert, AlertImage, WazeImage } from '../../../assets/Images';
import { loginPageStyles } from '../../../styles';
import WazePopup from '../../Rider/Popups/Waze';
import SelectStatus from '../ChooseStatus';
import { Button, Box } from '@mui/material';
import PropTypes from 'prop-types';
import { Badge } from '../../../Components';

const PickUpDetail = (props) => {
  const [open, setOpen] = React.useState(false);
  const classes = loginPageStyles();
  const buttonStyle = {
    fontFamily: 'Mulish',
    textTransform: 'capitalize',
    color: '#455066',
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '16px',
  };
  return (
    <>
      <Box
        sx={{
          bgcolor: 'background.paper',
          width: 1,
          display: 'flex',
          direction: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', gap: '4px' }}>
            {props?.urgentOrders > 0 && (
              <Badge name="Urgent Order" color="#EA4C59" />
            )}
            {props?.practice.non_route &&
              (props.currentValue === 'Assigned' ||
                props.currentValue === 'En-route') && (
                <Badge name="Non-route" color="#054E8B" />
              )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                maxWidth:
                  props.currentValue === 'Assigned' ||
                  props.currentValue === 'En-route'
                    ? '240px'
                    : '194px',
                width: '100%',
                lineHeight: '22px',
                alignItems: 'center',
              }}
            >
              <Box
                className={classes.heading10}
                sx={{
                  color: '#000000',
                  fontWeight: '700',
                  fontSize: '17px',
                  width: '100%',
                  maxWidth: '159px',
                }}
              >
                {props?.practice?.name}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  gap: '11px',
                  alignItems: 'center',
                }}
              >
                <img
                  src={ErrorAlert}
                  alt=""
                  style={{ width: '18px', height: '18px' }}
                />
                {props.distance && (
                  <Box
                    className={classes.heading}
                    sx={{
                      color: '#8493AE',
                      fontWeight: '400',
                      fontSize: '13px',
                      lineHeight: '16px',
                    }}
                  >
                    {props?.practice?.latitude &&
                    props?.practice?.longitude &&
                    props.locationCoordinates
                      ? Number(
                          geolib.convertDistance(
                            geolib.getPreciseDistance(
                              {
                                latitude: parseFloat(props?.practice?.latitude),
                                longitude: parseFloat(
                                  props?.practice?.longitude
                                ),
                              },
                              {
                                latitude: props?.locationCoordinates?.latitude,
                                longitude:
                                  props?.locationCoordinates?.longitude,
                              }
                            ),
                            'km'
                          )
                        ).toFixed(2)
                      : 'N/A'}
                  </Box>
                )}
              </Box>
            </Box>
            {props.enableWaze && (
              <Box onClick={() => setOpen(true)}>
                <Box
                  sx={{
                    display: 'flex',
                    width: '24px',
                    height: '24px',
                    opacity: '1',
                    '&:hover': {
                      opacity: '0.8',
                    },
                  }}
                >
                  <img src={WazeImage} alt="" />
                </Box>
              </Box>
            )}
            {open && (
              <WazePopup
                key={props.index}
                setOpen={setOpen}
                data={props?.practice}
              />
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <CallIcon
                sx={{
                  fontSize: 18,
                  marginRight: '7px',
                  color: '#8493AE',
                }}
              />
              <Box
                className={classes.heading}
                sx={{
                  fontSize: '12px',
                  fontFamily: 'Mulish',
                  fontWeight: '400',
                  lineHeight: '16px',
                  marginTop: '2.5px',
                  color: '#455066',
                }}
              >
                {props?.practice?.contact_number}
              </Box>
            </Box>
            {props.currentValue === 'Assigned' ||
            props.currentValue === 'En-route' ? (
              <Button variant="text" sx={{ padding: '0px' }}>
                <SelectStatus
                  variant="text"
                  key={props.index}
                  data={props?.practice}
                  currentValue={props.currentValue}
                />
              </Button>
            ) : (
              <Button
                variant="text"
                sx={{
                  width: '101px',
                  height: '20px',
                  borderRadius: '20px',
                  border:
                    props.currentValue === 'Delivered'
                      ? '2px solid #54CB83'
                      : '1px solid #8493AE',
                }}
                style={buttonStyle}
              >
                {props.currentValue}
              </Button>
            )}
          </Box>

          <Box
            sx={{
              display: props.style ? 'flex' : 'none',
              flexDirection: 'column',
              gap: '4px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box
                className={classes.heading10}
                sx={{
                  color: '#455066',
                  fontWeight: '700',
                  fontSize: '15px',
                  lineHeight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  maxWidth: '19px',
                  width: '100%',
                }}
              >
                {props.urgentOrders}
              </Box>

              <Box
                className={classes.heading}
                sx={{
                  color: '#455066',
                  fontWeight: '400',
                  fontSize: '13px',
                  fontFamily: 'Mulish',
                  lineHeight: '16px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Urgent Orders
                <img src={AlertImage} alt="" />
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box
                className={classes.heading10}
                sx={{
                  color: '#455066',
                  fontWeight: '700',
                  fontSize: '15px',
                  lineHeight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  maxWidth: '19px',
                  width: '100%',
                }}
              >
                {props.eOrders}{' '}
              </Box>
              <Box
                className={classes.heading}
                sx={{
                  color: '#455066',
                  fontWeight: '400',
                  fontSize: '13px',
                  fontFamily: 'Mulish',
                  lineHeight: '16px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                eOrders
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box
                className={classes.heading10}
                sx={{
                  color: '#455066',
                  fontWeight: '700',
                  fontSize: '15px',
                  lineHeight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  maxWidth: '19px',
                  width: '100%',
                }}
              >
                {props.manualOrders}
              </Box>
              <Box
                className={classes.heading}
                sx={{
                  color: '#455066',
                  fontWeight: '400',
                  fontSize: '13px',
                  fontFamily: 'Mulish',
                  lineHeight: '16px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Non-eOrders
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        onClick={() => {
          props.handleButton(props.index);
          props?.setDropDownHeight(!props?.dropDownHeight);
        }}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          cursor: 'pointer',
          bgcolor: '#ffffff',
        }}
      >
        <Button
          variant="text"
          sx={{
            py: '0px',
            ':hover': {
              bgcolor: '#ffffff',
              color: '#000000',
            },
          }}
        >
          {props.style ? (
            <KeyboardControlKeyIcon
              sx={{ fontsize: '27px', color: '#8493AE' }}
            />
          ) : (
            <KeyboardArrowDownIcon
              sx={{ color: '#8493AE', fontSize: '27px' }}
            />
          )}
        </Button>
      </Box>
    </>
  );
};
PickUpDetail.propTypes = {
  style: PropTypes.bool.isRequired,
  handleButton: PropTypes.func.isRequired,
  setDropDownHeight: PropTypes.func.isRequired,
  dropDownHeight: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  manualOrders: PropTypes.number.isRequired,
  eOrders: PropTypes.number.isRequired,
  urgentOrders: PropTypes.number.isRequired,
  currentValue: PropTypes.string.isRequired,
  enableWaze: PropTypes.bool.isRequired,
  practice: PropTypes.object.isRequired,
  distance: PropTypes.bool,
  locationCoordinates: PropTypes.object,
};
export default PickUpDetail;
